"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMultiselect = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_select_1 = __importDefault(require("react-select"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const formatOptionLabel = (data) => (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
    react_1.default.createElement("div", { style: {
            background: data.color,
            borderRadius: 6,
            height: 6,
            width: 6,
            marginRight: 6
        } }),
    data.label));
class InputMultiselect extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.onValueChange = (valuesArray) => {
            if (this.props.onValueChange === undefined) {
                return;
            }
            if (valuesArray) {
                if (this.props.widgetConfig.multiple !== false) {
                    if (!Array.isArray(valuesArray)) {
                        valuesArray = [valuesArray];
                    }
                    this.props.onValueChange({ target: { value: valuesArray.map((option) => option.value) } });
                }
                else {
                    this.props.onValueChange({ target: { value: valuesArray.value } });
                }
            }
            else {
                this.props.onValueChange({ target: { value: null } });
            }
        };
        this.selectShortcut = (value, e) => {
            if (this.props.onValueChange === undefined) {
                return;
            }
            if (e) {
                e.preventDefault();
            }
            if (this.props.widgetConfig.multiple !== false) {
                const valuesArray = (0, LodashExtensions_1._isBlank)(this.props.value) ? [] : this.props.value.slice(0); // shallow array clone
                valuesArray.push(value.value);
                this.props.onValueChange({ target: { value: valuesArray } });
            }
            else {
                this.props.onValueChange({ target: { value: value.value } });
            }
        };
        this.customFilter = (option, searchText) => {
            if (option.label.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }
            else {
                return false;
            }
        };
        this.onValueChange = this.onValueChange.bind(this);
        this.selectShortcut = this.selectShortcut.bind(this);
        this.customFilter = this.customFilter.bind(this);
    }
    render() {
        const shortcutButtons = [];
        let hasShortcuts = false;
        const actualValue = (0, LodashExtensions_1._isBlank)(this.props.value) ? [] : this.props.value;
        const actualValueToSort = [];
        const choices = typeof this.props.widgetConfig.choices === 'function'
            ? this.props.widgetConfig.choices(this.props.interview, this.props.path)
            : this.props.widgetConfig.choices;
        const selectOptions = choices
            .filter((choice) => {
            return (choice.hidden !== true &&
                surveyHelper.parseBoolean(choice.conditional, this.props.interview, this.props.path, this.props.user));
        })
            .map((choice) => {
            const label = surveyHelper.translateString(choice.label, this.props.i18n, this.props.interview, this.props.path, this.props.user);
            const current = {
                label: label,
                color: choice.color,
                value: choice.value
            };
            if (actualValue.indexOf(choice.value) > -1) {
                actualValueToSort.push({
                    choice: current,
                    index: actualValue.indexOf(choice.value)
                });
            }
            return current;
        }, this);
        const actualValueWithLabel = actualValueToSort
            .sort((valueObjectA, valueObjectB) => {
            return valueObjectA.index - valueObjectB.index;
        })
            .map((v2s) => v2s.choice);
        if (this.props.widgetConfig.shortcuts) {
            hasShortcuts = true;
            for (let i = 0, count = this.props.widgetConfig.shortcuts.length; i < count; i++) {
                const shortcut = this.props.widgetConfig.shortcuts[i];
                // Make sure the corresponding option is available, otherwise don't add the shortcut
                if (selectOptions.findIndex((visiblechoice) => visiblechoice.value === shortcut.value) === -1) {
                    continue;
                }
                shortcutButtons.push(react_1.default.createElement("button", { key: 'shortcut' + i, type: "button", className: `button shortcut-button${shortcut.color ? ` ${shortcut.color}` : 'blue'}`, onClick: (e) => this.selectShortcut(shortcut, e), tabIndex: -1 },
                    shortcut.icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: shortcut.icon, className: "faIconLeft" }),
                    surveyHelper.translateString(shortcut.label, this.props.i18n, this.props.interview, this.props.path, this.props.user)));
            }
        }
        const customStyles = {
            option: (base, _state) => (Object.assign(Object.assign({}, base), { padding: '0.25rem 0.5rem' })),
            menu: (base, _state) => (Object.assign(Object.assign({}, base), { marginTop: '0' }))
        };
        // TODO: maybe we should jsut extend react select and accept any of its config in our component props
        return (react_1.default.createElement("div", { className: "survey-question__input-multiselect-container" },
            react_1.default.createElement(react_select_1.default, { "aria-labelledby": `${this.props.id}_label`, formatOptionLabel: formatOptionLabel, 
                //disabled={false}
                isMulti: this.props.widgetConfig.multiple !== false, onChange: this.onValueChange, options: selectOptions, filterOption: this.props.widgetConfig.onlyLabelSearch ? this.customFilter : undefined, isSearchable: true, isClearable: this.props.widgetConfig.isClearable || false, closeMenuOnSelect: this.props.widgetConfig.closeMenuOnSelect || (this.props.widgetConfig.multiple ? false : true), placeholder: "", name: `survey-question__input-multiselect-${this.props.path}`, value: this.props.widgetConfig.multiple !== false ? actualValueWithLabel : actualValueWithLabel[0], className: "react-select-container", classNamePrefix: "react-select", styles: customStyles }),
            hasShortcuts && shortcutButtons));
    }
}
exports.InputMultiselect = InputMultiselect;
exports.default = (0, react_i18next_1.withTranslation)()(InputMultiselect);
//# sourceMappingURL=InputMultiselect.js.map